<main-content
  [isNavigationCollapsed]="isNavigationCollapsed$ | async"
  (scrolledToPoint)='onScrolledToPoint()'
></main-content>
